import React, { Fragment, useEffect, useState } from 'react';
import Navbar from '../../../components/Navbar';
import { Button, Col, FormCheck, Row, Spinner, Toast } from 'react-bootstrap';
import { Controller, useForm } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { budgetAccounts, capitalBudgetAccounts, impactedOperatingBudgets, locations, operatingBudgetAccounts, PO } from '../utils';
import { NumericFormat } from 'react-number-format';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { useSelector } from 'react-redux';
import Axios from 'axios';
import { stringify } from 'querystring';

export const CreatePurchaseOrder = (props: any) => {
  const { user } = useSelector((state: any) => ({
    user: state.user,
  }));
  const [files, setFiles] = useState([]);
  const [submit, setSubmit] = useState(false);
  const [toastVisible, setToastVisible] = useState(false);
  const {
    register,
    handleSubmit,
    control,
    setValue,
    getValues,
    formState: { errors },
  } = useForm<PO>({
    defaultValues: {
      submittedBy: user.email,
    },
  });
  const onSubmit = handleSubmit(async (values: PO) => {
    //check for NaN budgetImpactAmount
    try {
      setSubmit(true);
      const formData = new FormData();

      if (files && files.length > 0) {
        console.log('files present');
        for (const file of files) {
          formData.append('files', file);
        }
      }

      formData.append('body', JSON.stringify(values));

      await Axios.post(`${(window as any)._env_.REACT_APP_SERVER}/po/create`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then((res) => {
          setToastVisible(true);
          setSubmit(false);
          // console.log('res: ', res.json())
          setTimeout(() => {
            window.location.replace('/purchaseOrders');
          }, 2000);
        })
        .catch((err) => {
          console.log('axios post err: ', err);
        });
    } catch (err) {
      alert('Error: /frontend/src/pages/PurchaseOrders/CreatePurchaseOrder/index//onSubmit');
      setSubmit(false);
    }
  });

  const handleQuote = (event: any) => {
    try {
      if (event.target.files[0]) setFiles([...files, event.target.files[0]]);
      console.log('quote handler');
    } catch (e) {
      alert('Error adding quote!');
    }
  };

  return (
    <Fragment>
      <Navbar />
      <Toast
        autohide
        style={{ backgroundColor: '#454545', color: '#ffffff', position: 'absolute', top: 75, right: '45%' }}
        show={toastVisible}
        onClose={() => setToastVisible(!toastVisible)}>
        <Toast.Body>PO Submitted Successfully!</Toast.Body>
      </Toast>
      <Row>
        <Col md={8}>
          <h1 className='m-2'>PO Form</h1>
        </Col>
        <Col md={4}>
          <div className='float-right m-2'>
            <Button type='submit' variant='info' className='mr-2' onClick={onSubmit}>
              {submit && <Spinner className='mr-1' as='span' animation='border' size='sm' role='status' aria-hidden='true' />}
              Submit
            </Button>
            <Button variant='primary' href='/purchaseOrders'>
              Cancel
            </Button>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <h5 className='ml-2'>Use this form to submit PO requests for OIT purchases.</h5>
          <h5 className='ml-2'>Approval will be handled and submitted as soon as possible by Jack Martin or Mike Tarquinio</h5>
          <h5 className='ml-2'>Upon approval, a handler will provide a PO number</h5>
          <br />
        </Col>
      </Row>

      <div className='ml-2 mr-2'>
        <form id='poForm' onSubmit={onSubmit}>
          <div className='row justify-content-start'>
            <div className='col-sm-3'>
              <div className='form-group'>
                <h5>
                  Email&nbsp;<span style={{ color: 'red' }}>*</span>
                </h5>
                <input
                  className='form-control'
                  {...register('submittedBy', {
                    required: true,
                  })}
                />
                <ErrorMessage errors={errors} name='submittedBy' render={({ message }) => <p style={{ color: 'red' }}>Email is required!</p>} />
              </div>
            </div>
            <div className='col-sm-3'>
              <div className='form-group'>
                <h5>
                  Date Required&nbsp;<span style={{ color: 'red' }}>*</span>
                </h5>
                <Controller
                  control={control}
                  name='dateRequired'
                  rules={{ required: true }}
                  render={({ field: { onChange, value } }) => (
                    <DatePicker
                      // disabled={getValues('dateRequired') !== '' || getValues('dateRequired') !== null}
                      openToDate={new Date()}
                      className='form-control col-sm'
                      selected={value ? new Date(value) : value}
                      onChange={onChange}
                      icon='calendar'
                    />
                  )}
                />
                <ErrorMessage errors={errors} name='dateRequired' render={({ message }) => <p style={{ color: 'red' }}>Date required!</p>} />
              </div>
            </div>
            <div className='col-sm-3'>
              <div className='form-group'>
                <h5>Vendor Name</h5>
                <input className='form-control' {...register('vendorName')} />
                <ErrorMessage errors={errors} name='vendorName' render={({ message }) => <p style={{ color: 'red' }}>Vendor Name is required!</p>} />
              </div>
            </div>
            <div className='col-sm-3'>
              <div className='form-group'>
                <h5>Vendor Address</h5>
                <input className='form-control' {...register('vendorAddress')} />
                <ErrorMessage
                  errors={errors}
                  name='vendorAddress'
                  render={({ message }) => <p style={{ color: 'red' }}>Invalid Vendor Address!</p>}
                />
              </div>
            </div>
          </div>
          <div className='row justify-content-start'>
            <div className='col-sm-3'>
              <div className='form-group'>
                <h6>&nbsp;</h6>
                <h5>
                  Dollar Amount&nbsp;<span style={{ color: 'red' }}>*</span>
                </h5>
                <Controller
                  name={'dollarAmount'}
                  control={control}
                  rules={{ required: true }}
                  render={({ field: { onChange, name, value } }) => (
                    <NumericFormat
                      className='form-control'
                      thousandSeparator={true}
                      allowNegative={false}
                      prefix={'$ '}
                      onValueChange={(v) => {
                        onChange(v.floatValue);
                      }}
                      value={value}
                    />
                  )}
                />
                <ErrorMessage
                  errors={errors}
                  name='dollarAmount'
                  render={({ message }) => {
                    return <p style={{ color: 'red' }}>Dollar Amount is required!</p>;
                  }}
                />
              </div>
            </div>
            <div className='col-sm-3'>
              <div className='form-group'>
                <h5>Location (Not Required)</h5>
                <h6>For Delivery, if applicable</h6>

                <Controller
                  control={control}
                  name='location'
                  render={({ field: { onChange } }) => (
                    <Typeahead
                      id='location'
                      options={locations}
                      placeholder='Choose location'
                      // labelKey=''
                      highlightOnlyResult
                      onChange={onChange}
                      clearButton
                    />
                  )}
                />
                <ErrorMessage errors={errors} name='location' render={({ message }) => <p style={{ color: 'red' }}>{message}</p>} />
              </div>
            </div>
            <div className='col-sm-3'>
              <div className='form-group'>
                <h6>&nbsp;</h6>
                <h5>Agreement Number</h5>
                <input className='form-control' {...register('agreementNo')} />
                <ErrorMessage errors={errors} name='agreementNo' render={({ message }) => <p style={{ color: 'red' }}>{message}</p>} />
              </div>
            </div>
            <div className='col-sm-3'>
              <div className='form-group'>
                <h6>&nbsp;</h6>
                <h5>Requisition Number</h5>
                <input className='form-control' {...register('requisitionNumber')}/>
                <ErrorMessage errors={errors} name='requisitionNumber' render={({ message }) => <p style={{ color: 'red' }}>{message}</p>} />
              </div>
            </div>
          </div>
          <div className='row justify-content-start'>
            <div className='col-sm-3'>
              <div className='form-group'>
                {/* <div className='form-inline'> */}
                <h5>Impacted Operating Budget</h5>
                <h6>Will this increase future year operating? Please indicate which year(s)</h6>
                {/* </div> */}
                <Controller
                  control={control}
                  name='impactedOperatingBudget'
                  render={({ field: { onChange } }) => (
                    <Typeahead
                      id='impactedOperatingBudget'
                      options={impactedOperatingBudgets}
                      // labelKey='budget'
                      clearButton
                      placeholder='Select year(s) from dropdown'
                      highlightOnlyResult
                      onChange={onChange}
                      multiple
                    />
                  )}
                />
                <ErrorMessage errors={errors} name='impactedOperatingBudget' render={({ message }) => <p style={{ color: 'red' }}>{message}</p>} />
              </div>
            </div>
            <div className='col-sm-3'>
              <div className='form-group'>
                <h5>Budget Impact Amount</h5>
                <h6>Enumerate the impact to listed budget</h6>
                <Controller
                  name={'budgetImpactAmount'}
                  control={control}
                  render={({ field: { onChange, name, value } }) => (
                    <NumericFormat
                      className='form-control'
                      thousandSeparator={true}
                      allowNegative={false}
                      prefix={'$ '}
                      onValueChange={(v) => {
                        onChange(v.floatValue);
                      }}
                      value={value}
                    />
                  )}
                />
                <ErrorMessage
                  errors={errors}
                  name='budgetImpactAmount'
                  render={({ message }) => {
                    return <p style={{ color: 'red' }}>Invalid value!</p>;
                  }}
                />
              </div>
            </div>
            <div className='col-sm-3'>
              <div className='form-group'>
                <h6>&nbsp;</h6>
                <h5>Budget Account Number</h5>
                <Controller
                  control={control}
                  name='budgetAccountNo'
                  rules={{ validate: (v) => v !== -1 }}
                  render={({ field: { onChange } }) => (
                    <Typeahead
                      id='budgetAccountNo'
                      options={budgetAccounts}
                      placeholder='Choose (Select Unknown if number unknown)'
                      // labelKey=''
                      highlightOnlyResult
                      onChange={onChange}
                      clearButton
                    />
                  )}
                />
                <ErrorMessage errors={errors} name='budgetAccountNumber' render={({ message }) => <p style={{ color: 'red' }}>{message}</p>} />
              </div>
            </div>

            <div className='col-sm-3'>
              <div className='form-group'>
                <h6>&nbsp;</h6>
                <h5>
                  Item Being Purchased&nbsp;<span style={{ color: 'red' }}>*</span>
                </h5>
                <input
                  className='form-control'
                  {...register('itemBeingPurchased', {
                    required: true,
                  })}
                />
                <ErrorMessage
                  errors={errors}
                  name='itemBeingPurchased'
                  render={({ message }) => <p style={{ color: 'red' }}>Item Being Purchased is required!</p>}
                />
              </div>
            </div>
          </div>
          <div className='row justify-content-start'>
            <div className='col-sm-1'>
              <div className='form-group'>
                <h5>
                  Renewal?&nbsp;<span style={{ color: 'red' }}>*</span>
                </h5>
                <div className='form-inline'>
                  <Controller
                    control={control}
                    name='renewal'
                    render={({ field: { onChange, value } }) => <FormCheck type='switch' id='renewal' checked={value} onChange={onChange} />}
                  />
                </div>
                <ErrorMessage errors={errors} name='renewal' render={({ message }) => <p style={{ color: 'red' }}>{message}</p>} />
              </div>
            </div>
            <div className='col-sm-2'>
              <div className='form-group'>
                <h5>For Public Safety?</h5>
                <div className='form-inline'>
                  <Controller
                    control={control}
                    name='forPublicSafety'
                    render={({ field: { onChange, value } }) => <FormCheck type='switch' id='forPublicSafety' checked={value} onChange={onChange} />}
                  />
                </div>
                <ErrorMessage errors={errors} name='renewal' render={({ message }) => <p style={{ color: 'red' }}>{message}</p>} />
              </div>
            </div>
            <div className='col-sm-3'>
              <div className='form-group'>
                <h5>Attach Quote Here</h5>
                <input {...register('quote')} type='file' name='quote' onChange={(e) => handleQuote(e)} />
                <ErrorMessage errors={errors} name='quote' render={({ message }) => <p style={{ color: 'red' }}>{message}</p>} />
              </div>
            </div>
          </div>
          <div className='row justify-content-start'>
            <div className='col-sm-6'>
              <div className='form-group'>
                <h5>Additional Information</h5>
                <h6>This field can be used to include any additional infomation necessary for the PO.</h6>
                <h6>Links to G Drive folders containing multiple attachments.</h6>
                <h6>Hardware/software requests</h6>
                <textarea className='form-control' {...register('additionalInfo')} />
                <ErrorMessage errors={errors} name='additionalInfo' render={({ message }) => <p style={{ color: 'red' }}>{message}</p>} />
              </div>
            </div>
          </div>
        </form>
      </div>
    </Fragment>
  );
};
